<template>
  <div v-if="!setUser" class="userconfig-container">
    <div>USER MANAGEMENT</div>
    <div class="table-container">
      <b-table 
        striped 
        responsives 
        :items="users" 
        :fields="fields" 
        sticky-header="90%"
        @row-clicked="editUser"
      >
      </b-table>
    </div>
    <div>
      <b-button class="btn-legal mr-1" @click="addUser">Add New User</b-button>
    </div>
  </div>
</template>
</template>
<script>
  import {api} from '../services/config'
  import axios from 'axios'
  export default {
    name : 'legalconfig',
    data (){
      return {
        fields : [
          {key : 'name', label : 'Name', thClass: 'bg-head'},
          {key : 'email', label : 'Email', thClass: 'bg-head'},
          {key : 'role', label : 'Role', thClass: 'bg-head'}
        ],
        users : null
      }
    },
    created(){
      const self = this
      self.$store.dispatch('toggleSidebar', false)
      self.getUserData()
    },
    computed : {
      setUser(){
        this.getUserData()
      }
    },
    methods : {
      getUserData(){
        axios({
          method : 'GET',
          url : `${api}/api/v1/users`
        })
        .then(({ data }) => {
          this.users = data.data
        })
        .catch(error => {})
      },
      editUser(item){
        this.$ga.event({
          eventCategory: 'User',
          eventAction: 'click',
          eventLabel: `EDIT USER ${item.id}`
        });
        this.$router.push({ path : `/useredit/${item.id}`})
      },
      addUser(){
        this.$ga.event({
          eventCategory: 'User',
          eventAction: 'click',
          eventLabel: `ADD NEW USER`
        });
        const self = this
        self.$router.push('adduser')
      }
    }
  }
</script>
<style lang="scss">
  @import "~/assets/scss/components/userconfig.scss";
</style>